module.exports = __webpack_public_path__ + "static/media/power-hp7.750865c5.png";